import {
  Box,
  FormControlLabel,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  TextField,
  Grid,
  Switch,
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getProviderById, updateProviderAffiliateSetting } from '../../../api/cms/provider';

const ProviderAffiliateSetting = ({ data = [] }) => {
  const { providerId } = useParams();
  const [affiliateSettingsState, setAffiliateSettingsState] = useState([]);
  const { data: providerInfo } = useSWR(
    ['providerById', providerId],
    (_key, providerId) => getProviderById(providerId),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );

  useEffect(() => {
    const settings = providerInfo?.affiliate_settings || data;
    setAffiliateSettingsState(settings);
  }, [providerInfo, data]);

  const onChangeAffiliate = async (enabled, affiliateData) => {
    try {
      const payload = {
        provider_affiliates: {
          category_code: affiliateData.category,
          enabled: enabled,
          logo: affiliateData.logo,
        },
      };

      await updateProviderAffiliateSetting(providerId, payload);

      setAffiliateSettingsState((prev) =>
        prev.map((item) =>
          item.category === affiliateData.category ? { ...item, enabled } : item,
        ),
      );
      if (enabled) {
        toast.success('Enabled successfully');
      } else {
        toast.success('Disabled successfully');
      }
    } catch (error) {
      toast.error('Failed to update settings');
    }
  };

  const handleToggle = (v) => (event) => {
    onChangeAffiliate(event.target.checked, v);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom component="div">
        Affiliate Settings
      </Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Grid item xs={12} style={{ margin: '15px auto' }}>
          <TableContainer component={Paper}>
            <Table aria-label="game table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Category</TableCell>
                  <TableCell>Enabled</TableCell>
                  <TableCell>Sort Order</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {affiliateSettingsState.length > 0
                  ? affiliateSettingsState
                      .sort((a, b) => a.order - b.order)
                      .map((v, i) => (
                        <TableRow key={`tr-${i}`}>
                          <TableCell>{v.category.toUpperCase()}</TableCell>
                          <TableCell>
                            <FormControlLabel
                              control={<Switch checked={v.enabled} onChange={handleToggle(v)} />}
                            />
                          </TableCell>
                          <TableCell>
                            {v.is_edit_mode ? (
                              <FormControlLabel control={<TextField defaultValue={v.order} />} />
                            ) : (
                              v.order
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProviderAffiliateSetting;
